<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Pedagogie'
});
</script>
<template>
  <ka-container
    code="pedagogie-matchers"
    :data="page.$info.pedagogieMatchers">
    <!-- Container de page -->
    <ka-container code="container-de-page">
      <!-- Container titre -->
      <ka-container code="container-titre">
        <ka-text code="h-1">
          <h1 v-html="t('pedagogieMatchers.containerDePage.containerTitre.h1.value', `<strong>La pédagogie Matchers</strong>`)" />
        </ka-text>
        <!-- Fondements -->
        <ka-container code="fondements">
          <!-- F1 -->
          <ka-container code="f-1">
            <ka-icon
              code="icon"
              value="i-fa-solid:bullseye" />
            <ka-text code="la-formation-sadapte">
              <span v-html="t('pedagogieMatchers.containerDePage.containerTitre.fondements.f1.laFormationSadapte.value', `La formation s’adapte aux projets de l’entreprise`)" />
            </ka-text>
          </ka-container>
          <!-- F2 -->
          <ka-container code="f-2">
            <ka-icon
              code="icon-1"
              value="i-fa-regular:calendar-alt" />
            <ka-text code="un-coaching-court-et">
              <span v-html="t('pedagogieMatchers.containerDePage.containerTitre.fondements.f2.unCoachingCourtEt.value', `Un coaching court et régulier`)" />
            </ka-text>
          </ka-container>
          <!-- F3 -->
          <ka-container code="f-3">
            <ka-icon
              code="icon-2"
              value="i-fa-solid:thumbs-up" />
            <ka-text code="k-80-de-pratique-20">
              <span v-html="t('pedagogieMatchers.containerDePage.containerTitre.fondements.f3.k80DePratique20.value', `80% de pratique <br>20% de théorie`)" />
            </ka-text>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Container gauche -->
      <ka-container
        code="container-gauche"
        :xs="{ hidden: null }">
        <!-- Container 2 -->
        <ka-container code="container-2">
          <ka-text code="titre">
            <span v-html="t('pedagogieMatchers.containerDePage.containerGauche.container2.titre.value', `Tentez la pédagogie Matchers avec l'un de nos experts !`)" />
          </ka-text>
          <ka-image
            code="image"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/194`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.imageClick,
              alt: `Image`
            }"
            value="https://ucarecdn.com/ecbeff65-7148-43ef-b407-52c8a47b9032/Experte-digital-déborah.svg" />
          <ka-image
            code="image-1"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/398`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image1Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/118483a8-2431-4039-8d96-05842d54c1f2/Expert-Geoffroy.svg" />
          <!-- Container -->
          <ka-container code="container">
            <ka-text code="etre-accompagne-gratuitement">
              <span v-html="t('pedagogieMatchers.containerDePage.containerGauche.container2.container.etreAccompagneGratuitement.value', `Être accompagné gratuitement`)" />
            </ka-text>
            <ka-text code="vous-navez-pas-le">
              <span v-html="t('pedagogieMatchers.containerDePage.containerGauche.container2.container.vousNavezPasLe.value', `Vous n’avez pas le temps de chercher la formation idéale ? Contactez-nous ! En 15 min chrono nous identifions vos besoins pour vous composer une formation adaptée à vos outils, votre équipe et vos objectifs !`)" />
            </ka-text>
            <ka-button
              code="prendre-rendez-vous"
              :options="{
                ripple: true,
                href: `https://meetings.hubspot.com/christophe-pramil`,
                ariaLabel: `button`,
                click: page.prendreRendezVousClick
              }">
              <span v-html="t('pedagogieMatchers.containerDePage.containerGauche.container2.container.prendreRendezVous.value', `Prendre rendez-vous`)" />
            </ka-button>
          </ka-container>
          <ka-image
            code="image-2"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/288`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image2Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/ad4da1bc-6690-43b0-8d91-d487c69df7c0/Expert-Jules.svg" />
          <ka-image
            code="image-3"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/622`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image3Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/2555b865-47ad-413d-b2dc-418cab6529d4/Expert- Vanessa.svg" />
          <ka-image
            code="image-4"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/247`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image4Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/286f36ef-358f-494e-8b78-2b5dfcb6f147/Expert- Tuka.svg" />
          <ka-image
            code="image-5"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/195`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image5Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/8beecf17-f354-4f05-934c-f797b158911e/Expert- Olivier.svg" />
          <ka-image
            code="image-6"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/135`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image6Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/36108b2e-1ee8-46d7-b148-f93f31ecd4f8/Expert-Nicolas.svg" />
          <ka-image
            code="image-7"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/278725d6-e7b3-41e1-a175-35f1a4c32a16/Expert-Julien (1).svg" />
          <ka-image
            code="image-8"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/306`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image8Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/67c3f863-3536-4ab4-8b9c-523a3f7b919a/Expert-Olivia.svg" />
          <ka-image
            code="image-9"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/274`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image9Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/58929996-da0a-4035-9cd0-d84857604f06/Expert- Joanna.svg" />
          <ArgToutSavoirFinancementsDispo instance-class="arg-tout-savoir-financements-dispo--p58" />
          <ka-image
            code="image-10"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/158`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image10Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/5c96af61-054e-481a-895d-c0b3d26ba55f/Expert- Jean-Dominique.svg" />
          <ArgTitreCtaTexte
            instance-class="arg-titre-cta-texte--p58"
            text="Si vous souhaitez tout savoir sans plus attendre, vous pouvez également prendre rendez-vous gratuitement avec Anne pour de super conseils en formation et beaucoup d'écoute👌" />
          <ka-image
            code="image-11"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/265`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image11Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/ed046d8f-5338-4ca3-86de-06a577e73ad7/profil_expert_éric.svg" />
          <ka-image
            code="image-12"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/241`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image12Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
          <ka-image
            code="image-13"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/342`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image13Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/7c194199-ff26-4531-9634-315cb45ccd62/Expert-JF.svg" />
          <ka-image
            code="image-14"
            :options="{
              animationIn: `fadeIn`,
              href: `https://www.matchers.fr/expert/342`,
              ariaLabel: `image`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.image14Click,
              alt: `Image`
            }"
            value="https://ucarecdn.com/d8705612-ac6a-4399-812a-3807cd511b62/Expert-Adélaïde.svg" />
        </ka-container>
      </ka-container>
      <!-- Container droite -->
      <ka-container code="container-droite">
        <ka-text code="grace-a-la-reforme">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.graceALaReforme.value', page.$constants.graceALaReforme)" />
        </ka-text>
        <ka-text code="apprendre-savoir-faire">
          <h2 v-html="t('pedagogieMatchers.containerDePage.containerDroite.apprendreSavoirFaire.value', `Nos convictions `)" />
        </ka-text>
        <ka-text code="sous-titre">
          <h3 v-html="t('pedagogieMatchers.containerDePage.containerDroite.sousTitre.value', `<span style='background-color:transparent;'><strong>Apprendre ≠ Savoir-faire</strong></span>`)" />
        </ka-text>
        <ka-text code="apprendre-a-faire">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.apprendreAFaire.value', `<span style='background-color:transparent;'>Apprendre à faire un site internet sur WordPress avec une vidéo de 45 minutes ne veut pas dire que vous saurez faire un site sur WordPress après 45 minutes de visionnage. En général, le temps de visionnage n’est d’ailleurs qu’une petite partie de votre apprentissage. </span>`)" />
        </ka-text>
        <ka-image
          code="image-15"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Schéma expliquant pourquoi les phases d'aprentissages intense puis la pratique ne sont pas efficaces en terme de formation professionnelle.`
          }"
          value="https://ucarecdn.com/8c58f411-3524-43e3-b541-9ac63da792a9/" />
        <ka-text code="cet-exemple-peut-etre">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.cetExemplePeutEtre.value', `<span style='background-color:transparent;color:#000000;'>Cet exemple peut être appliqué à une<strong> formation de 3 jours</strong> en présentiel ou en visio avec un formateur expérimenté. Vous apprenez, vous notez, vous questionnez le formateur et vous faites même des cas pratiques. </span><br> <br><span style='background-color:transparent;color:#000000;'>Pourtant 👉 48h à peine après la formation vous n’arrivez pas à afficher cette satanée fenêtre, faire disparaître ce bloc de texte ou encore relier l’interface avec votre CRM. </span><br> <br><span style='background-color:transparent;color:#000000;'>Alors que faites vous ? Rebelotte : vous galérez, vous cherchez et si vous ne trouvez pas vous abandonnez ou lancez un appel à l’aide.</span>`)" />
        </ka-text>
        <ka-text code="se-former-en-passant">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.seFormerEnPassant.value', `<span style='background-color:transparent;'>Se former en passant par une <strong>phase d’apprentissage intense </strong>en une courte période présente<strong> deux risques</strong> : oublier vite et mettre en pratique laborieusement.</span>`)" />
        </ka-text>
        <!-- Container 2 -->
        <ka-container code="container-1">
          <ka-text code="text-1">
            <h3 v-html="t('pedagogieMatchers.containerDePage.containerDroite.container1.text1.value', `Ce que Matchers ne propose pas :`)" />
          </ka-text>
          <!-- Container -->
          <ka-container code="container-3">
            <ka-text code="text-gauche">
              <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container1.container3.textGauche.value', `❌  <span style='background-color:transparent;'><strong>Du contenu e-learning qui ne répond pas vraiment à votre objectif avec lequel vous devrez vous débrouiller sans pouvoir poser vos questions.</strong></span>`)" />
            </ka-text>
            <ka-text code="text-droite">
              <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container1.container3.textDroite.value', `❌  <span style='background-color:transparent;'><strong>Vous enfermer dans une salle avec des inconnus pour écouter les grands concepts théoriques d’un formateur qui n’a pas mis le pied dans une entreprise depuis 10 ans.</strong></span>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-2">
          <h3 v-html="t('pedagogieMatchers.containerDePage.containerDroite.text2.value', `L'efficacité avant tout `)" />
        </ka-text>
        <ka-text code="quitte-a-investir">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.quitteAInvestir.value', `<span style='background-color:transparent;color:#000000;'>“Quitte à investir du temps et de l'énergie dans une formation, autant en profiter pour faire avancer un projet en même temps”.</span>`)" />
        </ka-text>
        <ka-text code="k-5-objectifs">
          <h2 v-html="t('pedagogieMatchers.containerDePage.containerDroite.k5Objectifs.value', `Les 3 fondements de la pédagogie Matchers`)" />
        </ka-text>
        <ka-text code="text-3">
          <h3 v-html="t('pedagogieMatchers.containerDePage.containerDroite.text3.value', `Le learning by doing `)" />
        </ka-text>
        <ka-text code="lors-dune-formation">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.lorsDuneFormation.value', `Lors d’une formation Matchers, le temps d’apprentissage (ou visionnage pour l'exemple précédent) et le temps de reproduction sont combinés par une mise en application immédiate et concrète sur votre projet en cours.`)" />
        </ka-text>
        <ka-image
          code="image-16"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Schéma montrant que l'apprentissage par la pratique est plus productif, surtout accompagné d'un expert du métier ! `
          }"
          value="https://ucarecdn.com/82e41d2b-092b-4414-8c4f-8f5fe2aaeb5a/" />
        <ka-text code="notre-formule-magique">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.notreFormuleMagique.value', `<span style='background-color:transparent;color:#000000;'>Notre formule magique : “<strong>Learning by doing</strong>”. Vous apprenez en mettant les mains dedans. Ce modèle d’apprentissage changera votre vision de la formation. </span><br> <br><span style='background-color:transparent;color:#000000;'>Avec cette méthode, vous y passez <strong>moins de temps</strong> et vous obtenez <strong>plus de résultats</strong>.</span>`)" />
        </ka-text>
        <ka-image
          code="image-17"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Shéma montrant que par la production, l'expertise, les feedbacks et l'apprentissage, le learning by doing est un gain de temps et de productivité en formation.`
          }"
          value="https://ucarecdn.com/5068794a-2eec-4b72-ac1b-61e5dccfc7ed/" />
        <ka-text code="dailleurs-le-mot">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.dailleursLeMot.value', page.$constants.dailleursLeMot)" />
        </ka-text>
        <ka-text code="text-4">
          <h3 v-html="t('pedagogieMatchers.containerDePage.containerDroite.text4.value', `Une formation qui s’installe dans la durée`)" />
        </ka-text>
        <ka-text code="il-nest-pas-rare-de">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.ilNestPasRareDe.value', `Il n’est pas rare de constater qu’après avoir suivi une formation, on ne se souvient plus de tout. <span style='background-color:transparent;color:#000000;'>Mais est-ce réellement nous le coupable ou le temps qui s’est écoulé entre notre apprentissage et notre tentative d’application ?</span>`)" />
        </ka-text>
        <ka-text code="pour-construire-de">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.pourConstruireDe.value', `Pour construire de <strong>solides compétences </strong>qui résistent face au temps, il est préférable d’<strong>installer l’apprentissage sur le long terme</strong>. Pour cette raison, les formations Matchers s’appuient sur la <strong>pédagogie de l’alternance</strong>.`)" />
        </ka-text>
        <ka-image
          code="image-18"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Grâce à un apprentissage régulier de deux heures, faites une formation utile pour vous et votre entreprise, qui durera dans le temps.`
          }"
          value="https://ucarecdn.com/97c8eb9f-d66a-4390-a75c-835306670f01/" />
        <ka-text code="avec-des-sessions-a">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.avecDesSessionsA.value', `Avec des sessions à raison de 2 heures par semaine (en moyenne) le laps de temps entre chaque session vous permet de tenter de mettre en application, d’avancer sur votre projet en cours et de vous rendre compte de ce que vous avez oublié. À la prochaine session vous serez à nouveau guidé par l’expert pour tendre vers l’autonomie totale. 🚀`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-4">
          <!-- Témoignage -->
          <ka-container code="temoignage">
            <!-- Témoin -->
            <ka-container code="temoin">
              <ka-image
                code="image-19"
                :options="{
                  animationIn: `fadeIn`,
                  lazyOptions: {
                    throttle: 200,
                    once: true,
                    intersection: { threshold: 0.1 }
                  },
                  alt: `Image`
                }"
                value="https://ucarecdn.com/4b5feec1-e65f-42d2-be79-757ed485692a/" />
              <ka-text
                code="lili-co-gerante-du"
                inner>
                <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container4.temoignage.temoin.liliCoGeranteDu.value', `Lili <br>Co-gérante du Domaine d'Arton`)" />
              </ka-text>
            </ka-container>
            <!-- Textes -->
            <ka-container code="textes">
              <ka-text code="pour-notre-formation">
                <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container4.temoignage.textes.pourNotreFormation.value', `<span style='background-color:transparent;color:#000000;'>Pour notre formation Matchers, on n'arrivait pas les mains dans les poches. Au début de l’accompagnement nous avions prévu un calendrier et chaque semaine on bossait sur les sujets à traiter. À chaque session, l’équipe devait avoir fait ses devoirs pour pouvoir avancer avec l’expert. </span>`)" />
              </ka-text>
              <ka-text code="text-5">
                <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container4.temoignage.textes.text5.value', page.$constants.text5)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <ka-text code="text-6">
          <h3 v-html="t('pedagogieMatchers.containerDePage.containerDroite.text6.value', `Une formation au service d’un projet`)" />
        </ka-text>
        <ka-text code="a-chaque-entreprise">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.aChaqueEntreprise.value', `<span style='background-color:transparent;color:#000000;'>À chaque entreprise, ses besoins, ses outils, ses ressources humaines et budgétaires. Dans ce contexte d'unicité, comment une même formation pourrait correspondre à des entreprises différentes ? Et bien c’est impossible, aucune formation ne peut être copiée-collée si elle veut répondre à 100% au besoin d’une entreprise.</span><br> <br><span style='background-color:transparent;color:#000000;'>Matchers rend ses formations uniques en leur laissant la liberté d’être construites sur-mesure pour un projet.</span>`)" />
        </ka-text>
        <ka-text code="nous-avons-des-templates">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.nousAvonsDesTemplates.value', `<span style='color:#c2c2c2;'>Nous avons des templates de programmes de formation que l'entreprise peut challenger et que l’expert peut à son tour modifier et ré-écrire d’après le(s) objectif(s) propre(s) à l'entreprise.</span>`)" />
        </ka-text>
        <ka-image
          code="image-20"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Grâce à la pédagogie Matchers, développez les compétences de vos collaborateurs pour accélerer vos projets et booster votre entreprise.`
          }"
          value="https://ucarecdn.com/80b7fff2-68d2-4891-ae2d-127634c4c9e7/" />
        <ka-text code="notre-pedagogie-prend">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.notrePedagogiePrend.value', `Notre pédagogie prend le problème à l’envers mais dans le bon sens ✅ Faire avancer le projet a pour source mais également pour impact de faire monter l’équipe en compétences. C’est à travers ce cercle vertueux que nous retrouvons notre méthode d’apprentissage, le learning by doing.`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-5">
          <!-- Témoignage -->
          <ka-container code="container-6">
            <!-- Témoin -->
            <ka-container code="container-7">
              <ka-image
                code="image-21"
                :options="{
                  animationIn: `fadeIn`,
                  lazyOptions: {
                    throttle: 200,
                    once: true,
                    intersection: { threshold: 0.1 }
                  },
                  alt: `Image`
                }"
                value="https://ucarecdn.com/0d6f92f6-f9ab-401e-8c5a-aded1d923458/" />
              <ka-text
                code="laurent-fondateur"
                inner>
                <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container5.container6.container7.laurentFondateur.value', `Laurent<br>Fondateur de Digifield`)" />
              </ka-text>
            </ka-container>
            <!-- Textes -->
            <ka-container code="container-8">
              <ka-text code="chaque-session-de">
                <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container5.container6.container8.chaqueSessionDe.value', `<span style='background-color:transparent;color:#000000;'>Chaque session de notre formation en webdesign représentait une date butoire à laquelle nous devions avoir avancé et arriver avec notre travail. </span><br> <br><span style='background-color:transparent;color:#000000;'>À chaque échange l'expert nous formait pour optimiser les interfaces que nous lui présentions. Il nous prévenait des problèmes potentiels et nous donnait les clés pour poursuivre notre projet . Ce n'était pas juste une formation, l'expert semblait même faire partie de l’équipe.</span>`)" />
              </ka-text>
              <ka-text code="text-7">
                <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container5.container6.container8.text7.value', page.$constants.text7)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <ka-text code="text-8">
          <h3 v-html="t('pedagogieMatchers.containerDePage.containerDroite.text8.value', `Des objectifs personnalisés`)" />
        </ka-text>
        <ka-text code="les-formations-matchers">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.lesFormationsMatchers.value', `<span style='background-color:transparent;color:#000000;'>Les <strong>formations</strong> matchers sont <strong>sur-mesure </strong>pour permettre de fixer des <strong>objectifs pédagogiques</strong> d’après les objectifs de l’un de vos projets. Tout le programme qui en découle doit s’adapter à l’environnement quotidien de votre équipe.</span>`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-9">
          <ka-image
            code="image-22"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Les formations Matchers s'allignent avec les objectifs de l'entreprise en répondant aux objectifs pédagogiques des collaborateurs formés.`
            }"
            value="https://ucarecdn.com/a910b97f-2c4c-49a8-8cf3-a0485d121e07/" />
          <!-- Container -->
          <ka-container code="container-10">
            <ka-text code="lequipe-et-lexpert">
              <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container9.container10.lequipeEtLexpert.value', `<span style='background-color:transparent;color:#000000;'>L’équipe et l’expert Matchers vous aident à traduire les objectifs d’un projet en objectifs pédagogiques.</span>`)" />
            </ka-text>
            <ka-text code="une-formation-en">
              <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.container9.container10.uneFormationEn.value', `<ul><li><span style='background-color:transparent;'>Une formation en marketing automation doit se baser sur les outils dont vous disposez.</span></li><li><span style='background-color:transparent;'>Une formation en SEA doit prendre en compte votre budget. </span></li><li><span style='background-color:transparent;'>Une formation en UI/UX doit s’adapter au niveau des apprenants.</span></li></ul>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="si-nous-devions-resumer">
          <span v-html="t('pedagogieMatchers.containerDePage.containerDroite.siNousDevionsResumer.value', `Si nous devions résumer notre volonté ; proposer des formations VRAIMENT UTILES. <br> <br>Pour cela, Matchers se fixe une exigence 👉 que la formation soit au service de l’un des projets en cours dans l'entreprise. `)" />
        </ka-text>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { pedagogie } from './store'
import ArgTitreCtaTexte from '~/components/ArgTitreCtaTexte/index.vue'
import ArgToutSavoirFinancementsDispo from '~/components/ArgToutSavoirFinancementsDispo/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p58')
const appData = appDataStore()
const page = pedagogie()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
